export const EmailIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
            <g clipPath="url(#clip0_1237_250)">
                <path d="M22 6.91016C22 5.81016 21.1 4.91016 20 4.91016H4C2.9 4.91016 2 5.81016 2 6.91016V18.9102C2 20.0102 2.9 20.9102 4 20.9102H20C21.1 20.9102 22 20.0102 22 18.9102V6.91016ZM20 6.91016L12 11.9102L4 6.91016H20ZM20 18.9102H4V8.91016L12 13.9102L20 8.91016V18.9102Z" fill="white" />
            </g>
            <defs>
                <clipPath id="clip0_1237_250">
                    <rect width="24" height="24" fill="white" transform="translate(0 0.910156)" />
                </clipPath>
            </defs>
        </svg>
    )
}